import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_app_header = _resolveComponent("app-header");
  const _component_Button = _resolveComponent("Button");
  const _component_Field = _resolveComponent("Field");
  const _component_cell = _resolveComponent("cell");
  const _component_List = _resolveComponent("List");
  const _component_collapse_item = _resolveComponent("collapse-item");
  const _component_collapse = _resolveComponent("collapse");
  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_app_header, {
    title: "营业厅选择"
  }), _createElementVNode("div", null, [_createVNode(_component_Field, {
    modelValue: _ctx.posName,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.posName = $event),
    "left-icon": "search",
    placeholder: "输入关键字搜索门店"
  }, {
    button: _withCtx(() => [_createVNode(_component_Button, {
      size: "small",
      type: "primary",
      color: "#e89015",
      onClick: $setup.search
    }, {
      default: _withCtx(() => [...(_cache[2] || (_cache[2] = [_createTextVNode("搜索", -1)]))]),
      _: 1
    }, 8, ["onClick"])]),
    _: 1
  }, 8, ["modelValue"]), _createVNode(_component_collapse, {
    modelValue: _ctx.activeNames,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _ctx.activeNames = $event)
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.shops, (areaItem, key) => {
      return _openBlock(), _createBlock(_component_collapse_item, {
        title: key,
        key: key
      }, {
        default: _withCtx(() => [_createVNode(_component_List, null, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(areaItem, shop => {
            return _openBlock(), _createBlock(_component_cell, {
              key: shop.id,
              title: shop.shopName,
              onClick: $event => $setup.selectShop(shop)
            }, null, 8, ["title", "onClick"]);
          }), 128))]),
          _: 2
        }, 1024)]),
        _: 2
      }, 1032, ["title"]);
    }), 128))]),
    _: 1
  }, 8, ["modelValue"])])]);
}